export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 4.785,
        "transcript": "Aipangellruunga taumek, aipangellrulliniunga.",
        "translation": "He became my husband or had become my husband."
    },
    "2": {
        "startTime": 5.285,
        "endTime": 26.73,
        "transcript": "Tuai-ll taum pianga 'kitak tuai itra, aturaten ukut itrauciiqanka waniku.'  Kiani, uani Kegg'ukarmiut kiaqliitni uitaluta Kelliqucirmiuni-gguq wani.",
        "translation": "So after that one told me, 'ok now go up (place not said) and I'll bring your clothe later.'  We were at Kelliquciq located above Kegg'ukaq."
    },
    "3": {
        "startTime": 26.982,
        "endTime": 43.55,
        "transcript": "Aren, tua-i-llu itrarlua unuakuarmi yuut makut upalliniata kaminiarturayuitellratni ellakun saanilutullratni kenillerteggun.",
        "translation": "And so I walked up early morning because those people had moved at a time when stoves weren't used regularly and kettle water was boiled outside in a firepit."
    },
    "4": {
        "startTime": 43.79,
        "endTime": 64.891,
        "transcript": "Aren, tua-i itrarlua.  Tua-i yuut makut tuai tangvagqatnga tuai cukarikanirlua ulurluki piaqlua.  Aren tuai itrama tuai kiiryuama-llu wayarlua.  Taukut-llu ciunerma qaill pinrilatnga.",
        "translation": "Anyway, I walked up.  If those people looked at me, I would look away and speed up.  When I got in I was hot so I stripped my clothe.  The people there didn't do anything."
    },
    "5": {
        "startTime": 65.135,
        "endTime": 78.82,
        "transcript": "Wayarlua tuai.  Aanamall imum qaill pinrilan camek-llu qanrutevken'ii.  Wayarlua qavarniama tuai tayim qavallinilua.",
        "translation": "I stripped my clothe.  That mom of mine didn't do anything and say anything.  I stripped my clothe off and slept because I was sleepy."
    },
    "6": {
        "startTime": 79.13,
        "endTime": 88.883,
        "transcript": "Cunaug tuai tuaten aipanguciqall nallumanalluku.  Kiituan utertulluta kingunemtenun tekitukut.",
        "translation": "There, so I didn't even know for a long time I had been engaged.  We even went home and arrived at our place."
    },
    "7": {
        "startTime": 89.12,
        "endTime": 107.141,
        "transcript": "Cunauwagguq waniwa pitsaqutmek tauna angun ciullegyugciurluni.  Tua-i takarnirlua.  Tua-i tuaten tuai nallunrillruaqa.",
        "translation": "So then it happened by chance because the man was leary someone would beat him. I was spoken for.  That's how I found out about it."
    },
    "8": {
        "startTime": 107.37,
        "endTime": 123.29,
        "transcript": "Tua-i, uingqerruciqa nalluluku tuai yuulua.  Atam tuai uksuarumainanrani, uqtaqutullratni ingkut ellangvillrenka Sevv'arnermiut.",
        "translation": "So, little did I know I had a husband and continued my life.  It was by fall time when they speared fish where I became aware at Chefornak."
    },
    "9": {
        "startTime": 123.49,
        "endTime": 144.66,
        "transcript": "Tuani-qaa yuurtellruuten?  Ai, Sevv'arnirmiuni yuurtellrunritua.  Upnerkami-gguq Isrimiuni wani upnerkillerni May-aami yuurtellruunga.  Aatakuyartuan-llu-gguq kayangutellriartangqerrluni taun yuurtelqa.",
        "translation": "Were you born there.  What?  I was not born in Chefornak.  Spring season I was born in May at Isriq spring camp.  That evening someone found eggs where I was born."
    },
    "10": {
        "startTime": 144.95,
        "endTime": 150.111,
        "transcript": "Nateqsigta tauna Isrimiu, Isrimiut Sevv'arnermiut natiitni?",
        "translation": "Where exactly is Isriq, where were the people of Isriq from Chefornak?"
    },
    "11": {
        "startTime": 150.266,
        "endTime": 162.531,
        "transcript": "Ketiitni camani.  Ingriik-qaa tangeqsaitagken? Tanglaragka. Ingriik ketiigni.  Ingriik ingkuk ketiigni Qipnermiut aqikliigketa.",
        "translation": "Below them.  Have you seen those two mountains.  I've seen them.  Below the two  mountains.  Across from Kipnuk there are those two mountains, across from them two."
    },
    "12": {
        "startTime": 162.671,
        "endTime": 172.445,
        "transcript": "Nunaullruut-qaa taukut wall'u-qaa uksui... Nunarpauluteng nunauluteng enet amllerrluteng nevulget enet upnerkissuutait.",
        "translation": "Were they a village or a fall...They were a big village with lots of houses made of soil/mud for spring camping."
    },
    "13": {
        "startTime": 172.49,
        "endTime": 179.638,
        "transcript": "Ukaqliitwa cali Nuuteqerrmiut cali enet'arluteng qasgingqerraqluteng.",
        "translation": "And not far over from there were people of Nuuteqerr with houses and they had qasgiqs (mens house)."
    },
    "14": {
        "startTime": 179.787,
        "endTime": 187.8,
        "transcript": "Yaaqliitwa call ingkut Sevv'arnermiunek nutaan yulget Qikertaarmiut call yugyapiarluteng.",
        "translation": "Over from them were the people of Cevv'arneq and even more populated."
    },
    "15": {
        "startTime": 188.099,
        "endTime": 194.726,
        "transcript": "Canimeluulluteng tuai.  Qimugtet-llu nepliralriit alaitaqluteng.",
        "translation": "They were close together and you could hear their noise like dogs."
    },
    "16": {
        "startTime": 195.107,
        "endTime": 205.7,
        "transcript": "Yuut-llu tarritellriit alaitaqluteng.  Aren, canimelutqapiggluteng taukut upnerkillrit.",
        "translation": "People walking were visible.  So, their spring camps were very close."
    },
    "17": {
        "startTime": 205.96,
        "endTime": 217.1,
        "transcript": "Wanitaug imkut nauvillrenka wii ukaqliitnun Isrimiunun-gguq wavet upnerkitullruut.  Isrimiuni",
        "translation": " I grew up at Isriq spring camp not far over from other camps with Isriq people."
    },
    "18": {
        "startTime": 217.53,
        "endTime": 234.5,
        "transcript": "Aren-qia-paall upnerkiluteng.  Makut-wa tang avatiitni ircinraruugaat.  Uurcartangnaurtuqlu nunanun-llugg waniug tekitarkaurrluni uurcaq taun tamarluni.",
        "translation": "Oh my, they spring camped.  Around them were many little people.  There would be someone coming to a village carrying a gaff as a signal that he had caught a sea mammal but before reaching the village the person with the gaff would no longer be there."
    },
    "19": {
        "startTime": 234.713,
        "endTime": 252.619,
        "transcript": "Tamaqerrtelluku-llu maaken caniatnek ikamrat makut qavciinguluteng-llu tayim ketmurrluteng.  Ketmurqaarluteng yuut taukut nunat ukut upnerkilriit ciungatni piurluteng tamakut ircinraat.",
        "translation": "After his disappearance there appeared several sleds heading down.  After they go down, those little people were doing things ahead of the spring campers."
    },
    "20": {
        "startTime": 253.076,
        "endTime": 271.732,
        "transcript": "Ciungatni tuai piurluteng.  Ikamrat makut ketmurqaarluteng, kelutmurrnaurtut ikamrait-wa kavirpak.  Imaqaarluteng unguvalrianek.",
        "translation": "They were doing things ahead of them.  The sleds would go down and return with sled full of red color and plum full of sea mammal."
    },
    "21": {
        "startTime": 271.876,
        "endTime": 285.16,
        "transcript": "Tua-i-ll atakuqerrluku tayima tuai ikamrat imkut maavet tuai ingriik tungiignun ayagaqluteng.",
        "translation": "So, it would be evening when those sleds came by and they would be going towards the two mountains."
    },
    "22": {
        "startTime": 286.59,
        "endTime": 296.17,
        "transcript": "Atakuqerluku nutaan uurcartangluni waken nunanek kingunelegmek upnerkilrianek.",
        "translation": "So, that evening there appeared someone holding a gaff signaling catch who was a camper from this village."
    },
    "23": {
        "startTime": 296.715,
        "endTime": 305.218,
        "transcript": "Tuai-llu qasgitangqellruuq elatemteggun egguun qasegpagmek qasegpaagayagarmek.",
        "translation": "And so there was a semi-subterranean house right next to us there, a semi-subterranean house, kinda big semi-subterranean house."
    },
    "24": {
        "startTime": 305.35,
        "endTime": 314.785,
        "transcript": "Ap'aurlurput una Avngum-gguq una atii tailuni qasgim kepneranun pikavet aqumqerrluni",
        "translation": "Our poor grandfather, he was Avnguq's father came over and sat above the ground entrance to semi-subterranean house."
    },
    "25": {
        "startTime": 315.094,
        "endTime": 321.127,
        "transcript": "un'a uurcaq tagelria ukavet tuai aturpauqurrluku.",
        "translation": "He sang for the one holding a gaff/stick  coming up."
    },
    "26": {
        "startTime": 321.49,
        "endTime": 330.036,
        "transcript": "Wangkuta-aug tua-i naseknagni tan'gaurluut-llu unglumakevvut ungluluuku niicugnikvut.",
        "translation": "Us girls and boys were like a nest around him listening to him."
    },
    "27": {
        "startTime": 330.472,
        "endTime": 341.65,
        "transcript": "Aren, kiituani-tang yuarutii-llu elitarput.  Waten tang atuutullrulria tauna uurcaq tangvaurluku.",
        "translation": "My, we even learned his song.  He sang like this with his eyes on that gaff holder."
    },
    "28": {
        "startTime": 342.0,
        "endTime": 367.74,
        "transcript": "Uurcaaraiyaayarraa Aiyiyaa, Aiyiyaa Tan'guaravluarrlug'aat.  Issurissur issurissur Maklaassiiyaayagg'aa Aaiyiyaa, Aiyiyaa Tan'guaravluarrlug'aat.",
        "translation": "(The young one holding the gaff needs help. Aiyiyaa Aiyiyaa All you young boys. Spotted Seal Spotted Seal Bearded Seal Aiyiyaa All you young boys."
    },
    "29": {
        "startTime": 367.91,
        "endTime": 390.16,
        "transcript": "Tua-i elicingqapiggluku wangkuta niicugnistaini.  Uurcam-llu imum tekicami urenkelluku ciuqerraanun nangercami.  Negcikcuaraminek, negcikcuarani wavet kapuarrluku qanemciluni.",
        "translation": "We really wanted to learn as we listened to him.  The hunter after he carefully stood in front of him holding a gaff/stick, poked his stick aside and said a story."
    },
    "30": {
        "startTime": 390.94,
        "endTime": 398.9,
        "transcript": "Aqvalgir, aqvalgirarkanek, aqvalgirarkat qanrulluki.  Tua-i aren",
        "translation": "Telling the ones who will retrieve his catch.  So, then"
    },
    "31": {
        "startTime": 399.17,
        "endTime": 415.36,
        "transcript": "Imkut ircinraat ciungatni pillret amllertatait ikamrat unuaquaqan ketmurrnaurtut.  Amllertacirkait cunaug tuai ciungatni maniurluki tamakut.",
        "translation": "those little people presented ahead of them how many sleds were going down each day.  They showed that the same would happen as them."
    },
    "32": {
        "startTime": 416.53,
        "endTime": 427.35,
        "transcript": "Iling, tua-i amllertatait imkut ketmurtellret unuaquaqan aqvalgirluteng tayim ayaganaurtut.  Aren, uksuuluku.",
        "translation": "Oh my, the same amount as those (little people sleds) traveled each day to go get the catch.  And, it was winter."
    },
    "33": {
        "startTime": 428.27,
        "endTime": 435.056,
        "transcript": "Upnerkilriit imkut egkuiruqaqnaurtut natermun-llu ciptaqluteng.",
        "translation": "At that spring camp they filled the back wall and place more on the floor."
    },
    "34": {
        "startTime": 435.108,
        "endTime": 448.1,
        "transcript": "Unguvalrianek egkurpallraat qaugkut upnerkissuutet enet egkuit unguvalrianek muirluteng natermun ciptaqluteng.",
        "translation": "They filled up the large back wall/corner with sea mammal inside those spring houses full and some on the floor."
    },
    "35": {
        "startTime": 448.54,
        "endTime": 458.12,
        "transcript": "Aren-qia-pakar, tuaten tuai angullrenka augkut ayuqellruut.  Kitek uitaqaqaa kenriutelliniuq-am una.",
        "translation": "Oh my goodness, that's how they were the ones I saw.  Hold on, we're running out of battery power."
    },
    "36": {
        "startTime": 458.19,
        "endTime": 489.67,
        "transcript": "Ukut tutgarma irniari cali iluperanka.  Pangall'am yuin alqaat, Nuraar-wa pi-wa Qussauyaq-wa, Arnaquq-wa, Dick-aaq-wa ugnaug kinguqlikacagiit Nanugaq.  Ii-i",
        "translation": "My grandchildren's children, my great grandchildren.  Pangall'aq's children oldest daughter, Nuraar, Qussauyaq, Arnaquq, Dick, and the last of them down river is Nanugaq.  Yes"
    },
    "37": {
        "startTime": 490.32,
        "endTime": 507.201,
        "transcript": "Uyangqulriim-wa cal' irniari talliman, arvinerkaatnek evai aqsangluni.  Miisaam-wa cali irniari pingayun.",
        "translation": "And, there are Uyang'qulria's five children, sixth is growing in her belly.  Also, Miisaq's three children."
    },
    "38": {
        "startTime": 507.67,
        "endTime": 523.89,
        "transcript": "Ciulluum-wa call irniara ugg atauciq kinguqlirkai irnicuaruurluteng nuringarmeng an'urluteng.  Tallimaurcaaqluteng taukut nuringarmeng anellret.",
        "translation": "Downriver, Ciulluk's one child who had five siblings following him who weren't complete but miscarriaged."
    },
    "39": {
        "startTime": 524.36,
        "endTime": 531.217,
        "transcript": "Kinguqlirkai uum Ciulluum yuan.  Tua-i",
        "translation": "They were going to be after Ciulluks child."
    },
    "40": {
        "startTime": 531.89,
        "endTime": 545.32,
        "transcript": "Ingkut-wa cali Kuigilngurmi Akat'am irniari cali ingkut iluperanka.  Atam alqaat maantuq.",
        "translation": "And over at Kwigillingok Akat'aq's children are also my great grandchildren.  Their oldest sister is hree."
    },
    "41": {
        "startTime": 548.98,
        "endTime": 565.66,
        "transcript": "Tung'ii-wa tayim cali Cevv'arnermi cali ukurisngaluuni.  Taugaam tailartuq angayuqaagminun.",
        "translation": "The second is now in Chefornak with her in-laws.  She visits her parents."
    },
    "42": {
        "startTime": 570.55,
        "endTime": 594.82,
        "transcript": "Alaitelallruut ak'a avani nallevni.  Nallemni amllellruut angalkut.  Kitak tamakunek wani qanemcitqerkut.  Waten niitelartukut maa-i wani assilriit-gguq angalkuut assiitellriit-llu angalkuut.  Piciatun pilliunga wiinga nallunritaten elpet kitak qanemciqaa tamakunek. II-i",
        "translation": "They were seen back then.  There were many shaman in my time.  Okay, tell us those stories.  We hear now, there were good medicine man and not good medicine man.  I could be random but you know them so please converse to us about them.  Yes"
    },
    "43": {
        "startTime": 595.05,
        "endTime": 612.065,
        "transcript": "Ilait maaten im angalkut murilkenganka tamakut ilait makut yuut qinuciakaqluki. Tuquqatalriit-ll ilait qinuciaraaqluteng angalkugmek taumek qinuciaracirluteng.",
        "translation": "When I started to notice some of the shamans, some people back then were upset about them.  Some about to die; upset or fussing about that medicine man."
    },
    "44": {
        "startTime": 612.385,
        "endTime": 623.873,
        "transcript": "Tuquqatalriit ilait tuaten tuatnaaqluteng taumun tuaten piniluteng.  Qinurciaraaqluteng.",
        "translation": "Some about to die went through that; saying that one is doing something to them.  Upset that (medicine man) was doing something to them.  Fussing"
    },
    "45": {
        "startTime": 624.349,
        "endTime": 634.53,
        "transcript": "Ilait taugken makut angalkuuniyaaqengraiceteng watqapik camek qanernaaraunateng angalkuugaqluteng.",
        "translation": "There were some labeled as medicine man but there was absolutely nothing said about them living as shaman/medicine man."
    },
    "46": {
        "startTime": 634.76,
        "endTime": 645.262,
        "transcript": "Makutun yuunginaarartun ayuqaqluteng qaill qanernaunateng.  Tua-i taugaam tamakunek avulluguutengqelallruut.",
        "translation": "They were like regular people and they conversed good things about them.  But, there were those that were bad (shaman) among them."
    },
    "47": {
        "startTime": 645.93,
        "endTime": 654.14,
        "transcript": "Tangerrluku ilungarluan wiinga-llu angalkurtellrulrianga.  Tang.",
        "translation": "You see, my dear cousin I also was visited by a medicine man.  See"
    },
    "48": {
        "startTime": 654.4,
        "endTime": 670.42,
        "transcript": "Angalkurtellrulrianga qavamkun.  Tua-i maaten tang-im ellangua.  Qanemcitnaamken.  Yuilqumi ellangua waten kiirarma aqumgalrianga nunam qaingani.",
        "translation": "I was visited by a medicine man in my sleep.  So, I became aware.  Let me tell you about it.  I became aware being in the wilderness sitting alone on the tundra."
    },
    "49": {
        "startTime": 670.78,
        "endTime": 678.693,
        "transcript": "Maaten tang caqalriamek niicama ukatmun takuyartua amig una.",
        "translation": "And then I heard something and looked back this way and saw a door."
    },
    "50": {
        "startTime": 679.08,
        "endTime": 687.82,
        "transcript": "Talliq-wa tang man, tallirpilernek nuna man tua-i agturturluku agiirtellria.",
        "translation": "There was an arm, right side touching the tundra moving towards me."
    },
    "51": {
        "startTime": 687.99,
        "endTime": 694.156,
        "transcript": "Umyuarteqaartua, aling aren assilriarunripagta tanem man'a.",
        "translation": "I immediately thought, oh gosh that doesn't look good coming my way."
    },
    "52": {
        "startTime": 695.106,
        "endTime": 716.72,
        "transcript": "Ayumian tekipailganga yaaqsig'aan piicaglua qavamni camani atanermun ikayuusqellua.  Man'a-llu agiirtellria tekiteqatarteka wiinga ingluliurutkaanek neqanaitnilua.  Nallunritnilua.",
        "translation": "Then, before it reached me because it's kind of far I prayed in my deep sleep for God to help me.  I also said that thing moving towards me was beyond my ability to fight it.  I knew that."
    },
    "53": {
        "startTime": 717.01,
        "endTime": 730.29,
        "transcript": "Ayuqiikun ingluliurutkaitnilua.  Piniliisqellua taugaam.  Pinimek cikiisqellua mat'um tung'iinun.",
        "translation": "I didn't have the same skill to go against it.  But to give me strength.  Give me strength towards it."
    },
    "54": {
        "startTime": 739.296,
        "endTime": 758.03,
        "transcript": "Tekitellerkamnek qungvangama taqngama uitua.  Waten cetungqallemni irugma akunliigni uluaqa una ulurpaller.",
        "translation": "It was getting creepy before it reached me, and done I woke up.  As I was sitting like this there was between my legs my big curved knife."
    },
    "55": {
        "startTime": 758.588,
        "endTime": 774.6,
        "transcript": "Qaill taun tailarta?  Amtall wii yuilqumllua. Teguqerluku.  Teguqaamku tangraqa maa-i tuai tekiteqatallinikiinga.",
        "translation": "How did it get to me?  And, I was out in the wilderness.  I took it.  After taking it I saw it was almost getting to me."
    },
    "56": {
        "startTime": 774.784,
        "endTime": 793.19,
        "transcript": "Atam tua-i caunqegcaqka. Tua-i caungamku maa-i tua-i tekiteqaataanga waten wavet ciisqumigglua uluaq waten epuakun tegukeka inglugtun.",
        "translation": "Look, I turned my body to face it.  When I faced it, it was about to get to me I was on my knees here holding the curved knife by the handle with both hands."
    },
    "57": {
        "startTime": 793.86,
        "endTime": 802.522,
        "transcript": "Tuani piicag'aarlua uitellruunga ayuqucimtun ayuqevkenii tua-i pinirngan'ii-llu.",
        "translation": "At that time after I prayed I woke up not myself and felt strong."
    },
    "58": {
        "startTime": 804.339,
        "endTime": 818.73,
        "transcript": "Tua-lli-wa tua-i maavet unatet elliata waten tallirpilerneret, wavet uluaq tua-i waten piqerluku elliikeka.",
        "translation": "Noticing the hands were here, like the right side, I put the curved knife and placed it like so."
    },
    "59": {
        "startTime": 819.052,
        "endTime": 832.606,
        "transcript": "Tua-lli-wa tua-i qiagyigtellria qelempagluall wii.  Tua-i qiagyigtellria.  Atam qiagyigquraqerluni nunamun kapuartell.",
        "translation": "I felt it grinding and I closed my eyes.  It was grinding.  While grinding for a bit it poked into the ground."
    },
    "60": {
        "startTime": 833.1,
        "endTime": 843.06,
        "transcript": "Call'im qalriuciiyaarluni.  Tuar caviyaaqlu qalrialria.  Tayima tua-i qungagarrluni.",
        "translation": "It made a calling noise again.  As in a metal wire making a calling noise.  And then it shrunk."
    },
    "61": {
        "startTime": 843.281,
        "endTime": 856.582,
        "transcript": "Aren takuyarqa tallir im tayima.  Aren umyuarteqaartua unaug uluaq nunamun kapusngalria egkuaminun puukaumaluuni.",
        "translation": "So, I looked back the arm was gone.  So, I thought and here was an uluaq poked into the ground up to its handle."
    },
    "62": {
        "startTime": 856.904,
        "endTime": 874.49,
        "transcript": "Aren, waniwaq cullmerciaqa augna.  Taugaam kilirngacaaqaqa.  Maaten tang im tua-i makcama man'a avateka kiartaqa.  Aren unatet makut maani avatemni petgalriit.",
        "translation": "So, did I miss that one.  It seems I cut it though.  And so I got up and looked around me.  There were hands bouncing around me."
    },
    "63": {
        "startTime": 874.866,
        "endTime": 899.24,
        "transcript": "Cavkenateng petgalriit qeckaraqluteng.  Malirqeraaluki tuai cakiteraqluki kiituan uitangut.  Uitangata qupurrluki piciatun egqaqluki.  Makut yuarat piciatun egtaqluki quyungqavkarpeknaki.",
        "translation": "They didn't do anything but bounce up and jump.  I ran after them to chop them and soon they are still.  As they're still I cut them and threw them any which way.  There were fingers I was throwing separating them."
    },
    "64": {
        "startTime": 899.78,
        "endTime": 917.104,
        "transcript": "Tua-i nutaan caarkaicukaama nangerrlua uluaqa taun qelkarrluku.  Uterqurlua tuai yaani Kuigilngurmi.  Uterrqurlua.",
        "translation": "So, I was done doing that and stood up holding onto my curved knife.  I headed home to Kwigillingok.  I headed home."
    },
    "65": {
        "startTime": 918.674,
        "endTime": 942.43,
        "transcript": "Qavangurtulangellruunga tuaten tua tamakunek ayuqenrilngurnek uumun imumun Segg'amun, Segg'ar una.  Segg'am waten piyaaqellruangua. Alingnaqvaall usuuq tang, taangiqluni.",
        "translation": "I started having dreams like that of various kinds.  From this or that person Segg'aq because he had said to me when he was intoxicated."
    },
    "66": {
        "startTime": 942.615,
        "endTime": 945.769,
        "transcript": "Usuuq tang yuungcariqernaamken.",
        "translation": "\"You there, let me treat you.\""
    },
    "67": {
        "startTime": 946.384,
        "endTime": 955.16,
        "transcript": "Ingna-gguq, ingna-gguq tang yaai Ayaginaar yuungcarallra man'a tekiskii.",
        "translation": "\"I treated that one over there, Ayaginaar, who is living to this day.\""
    },
    "68": {
        "startTime": 955.32,
        "endTime": 968.94,
        "transcript": "Yuungcariqernaamken.  Eruurqavet ervuqaarqavet ervuqalaryartuten unaken taryumek eruutan avuqerluku.",
        "translation": "\"Let me treat you.  You will have to bathe yourself adding a little bit of salt water from down there to your wash water.\""
    },
    "69": {
        "startTime": 969.31,
        "endTime": 977.21,
        "transcript": "Tua-i-gguq elliin-llu caa im yuungcararkaq ilaaqluku yuungcaraqeciqa.",
        "translation": "He was going to continue to add to his work of healing as his."
    },
    "70": {
        "startTime": 977.83,
        "endTime": 981.85,
        "transcript": "Tautun Ayaginaartun.",
        "translation": "As he had to Ayaginaar."
    },
    "71": {
        "startTime": 982.41,
        "endTime": 997.9,
        "transcript": "Tua-i tamana umyuama pinrilaku. Piaqa wavet canritniluku waten quurang'erma.  Canritniluku waten quurang'erma.  Tuaten wii piiyuumiitnilua.",
        "translation": "In my mind, I didn't want to do that so I said to him looking at him it was okay for me to live the way I did, it was okay.  I didn't want to do it like that."
    },
    "72": {
        "startTime": 998.59,
        "endTime": 1006.06,
        "transcript": "Qavanguqevkalangellruuq tua-i tauna engelekluku ciuniunritelqa.",
        "translation": "So he came into my dream starting from then when I didn't accept his healing medicine."
    },
    "73": {
        "startTime": 1006.458,
        "endTime": 1016.87,
        "transcript": "Aa, tuani tua-i tayima tua-i qavanguqenrirluku.  Tuaten taugaam qavangurturaqlua canek tamakunek.",
        "translation": "Ah, I stopped dreaming about him.  But, I started to dream of those things."
    },
    "74": {
        "startTime": 1017.168,
        "endTime": 1022.35,
        "transcript": "Uterrlua tua-i tekillua.",
        "translation": "I went home and arrived."
    },
    "75": {
        "startTime": 1022.857,
        "endTime": 1040.91,
        "transcript": "Aren, maaten tang tuani kiartua taukut unatet kepraarluki.  Tuani tua-i upnerkaryarturtuq.  Alussistuallruluteng-llu waniug yaaqsigpeknani Alussistuallrat.",
        "translation": "Oh, at that instance I looked around after cutting up the hands.  It was early spring.  Christmas had just happened and it was not too long after Christmas."
    },
    "76": {
        "startTime": 1041.694,
        "endTime": 1053.18,
        "transcript": "Nuna man qaingna urullinilria tua-i.  Nanvat-llu makut urugaqluki.  Taugaam cikuit urumaksaunateng.",
        "translation": "The tundra had melted.  The ponds had melted.  But ice had not melted."
    },
    "77": {
        "startTime": 1053.84,
        "endTime": 1062.218,
        "transcript": "Makut-llu kuiget miiqaqtaangelliniluteng akulait.  Tua-i kiarrlua.",
        "translation": "There was water in between the rivers ice.  I looked around."
    },
    "78": {
        "startTime": 1062.363,
        "endTime": 1083.12,
        "transcript": "Nunam qainga tuaten ayuqluku.  Uterrlua tua-i tekicama tua-i enetenun itrama.  Qavauciqa nallunriqerrluku tua-i tupagyarturlua uigarrlua.  Tua-i uigarcama tua-i ateurluata imum qailpiciranga qanrulluku.",
        "translation": "The tundra was like that.  I went on home, and when I arrived and went in our house. I realized it was in my sleep and just about to wake up.  I opened my eyes.  When I opened my eyes, father asked how I was so I told him."
    },
    "79": {
        "startTime": 1086.116,
        "endTime": 1109.24,
        "transcript": "Qavangurturnilua augumek tua-i tuaten ayuqelriamek.  Waniwa tua-i qavanguqa augna piciukan qelluqurciqnilua upnerqarpak ellam ayuqucianek.  Tua-i waten-am qanruskilaku engelii tekitevkenaku.",
        "translation": "I told him what I dreamt of.  I said to him if my dream is true I will watch how the weather is all spring.  So, I said that to him even though I didn't tell the entire dream."
    },
    "80": {
        "startTime": 1109.81,
        "endTime": 1121.663,
        "transcript": "Tua-ill kelluqurlua tua-i imumi-llu avani pelatekiulallrat-qaa nallullruan Kuigilnguum painga pelatekalilallra.",
        "translation": "So, I kept watch of..you may not know where they pitched tents at the mouth of Kuigilnguq."
    },
    "81": {
        "startTime": 1122.013,
        "endTime": 1128.444,
        "transcript": "Tengmiarsuunkut kiingan anguqallruanka.  Nangenruluteng pingatellruut ellait.  Yaa,",
        "translation": "I think It was Tengmiarsuq's family who went there that I remember.  They were the last ones.  Yes"
    },
    "82": {
        "startTime": 1129.244,
        "endTime": 1149.107,
        "transcript": "Una wani ukalirnera Kuigulnguum pelatekat ungani amllepiatullruut uaqlirni.  Waniug cali kiaqliitni cali pelatekarugaat.  Agnall call akiqlirnek ikna pelatekartangqerraqluni pelatekrugarnek.",
        "translation": "This side of Kwigillingok had tents, down river there were alot of tents.  And, above them there were a lot of tents.  Across from there, there were alot of tents, as well."
    },
    "83": {
        "startTime": 1150.733,
        "endTime": 1179.147,
        "transcript": "Anelraquutullratni painganun Kuigilnguum.  Aren qiapakar.  Tua-i tuaten tua-i.  Anelrarluta tua-i ikani akilirnermi uitaluta wangkuta yugyagluteng.  Ilurarukall Avamarnaan-llu elaqliqlunuk.  Canritellrani tamani cayaugnaitellrani.",
        "translation": "They use to go there to the mouth of the river.  So, oh my.  That was how.  We went downriver and we stayed across the tent of many people.  My cousin, first child of Avamaq were next door to each other.  He was healthy, long before he went."
    },
    "84": {
        "startTime": 1179.567,
        "endTime": 1196.875,
        "transcript": "Atam tua-i uitaqainanemteni unaken tua-i unguvalriartaqengluteng. Itgayagikenka-am ukut qaqingnaqluki tuai-i itgayaagiarkanka augkut nayiit amiit.",
        "translation": "As we stayed there not long they were catching sea mammal.  I was skinning seal limbs and trying to finish skinning those limbs of skinned ring seal."
    },
    "85": {
        "startTime": 1197.105,
        "endTime": 1211.6,
        "transcript": "Atam piinanemteni yuk cakem amig ikireskii.  Pelatekangqertukut imumek tungupagmek tanqiucirluku qatellriamek qukaakun.",
        "translation": "As we were in our tent, the door opened from the entryway.  Our tent is a dark tent with light color in the middle to brighten inside."
    },
    "86": {
        "startTime": 1212.172,
        "endTime": 1227.039,
        "transcript": "Tua-i tuaten ayuqukut.  Qanertuq iterluni pamai yuk pam tunumni Qayum atiin canritlermini.",
        "translation": "That's what we were doing.  He said, coming in that person behind me and it was Qayuq's dad who was living then."
    },
    "87": {
        "startTime": 1227.268,
        "endTime": 1242.45,
        "transcript": "Tuall atrat una pia, Acill'aq pia.  Iluracung tang ikegkut ullakarki.  Tuai-gguq atatang elliin iluminek pivakaami ullanrilkai.",
        "translation": "So, he said to Acill'aq's name, 'my cousin go see them across the way.'"
    },
    "88": {
        "startTime": 1243.112,
        "endTime": 1260.922,
        "transcript": "Tuall piunga wii,  'cat imkut'.  Aren qanertuq, 'tauna-gguq Seg'aq yuunrirtuq.'  Aren, qaillun tua-i pivkenani.  Qaillun pivkenani tamani.",
        "translation": "So, I said, 'who are you referring to'.  He said, 'that one, Segg'aq has died.'  There was nothing happening to him.'  He was fine."
    },
    "89": {
        "startTime": 1261.3,
        "endTime": 1276.48,
        "transcript": "Aren piunga, 'Qaillun un pia?'  Tuai-gguq-wam antelallni antellerminiu tua-i yuunrilria.  Qecingarcami.",
        "translation": "I said, 'how did he die?'  He was spitting blood as he does and died.  He started spitting."
    },
    "90": {
        "startTime": 1277.253,
        "endTime": 1292.101,
        "transcript": "Aren qia, tua-ill tayiima tua-i qerarlutek maliklutek.  Qeraagnek caliyuumiircama calianka pegluki an'ngama nunam qainga kiartaqa.",
        "translation": "Oh no, so the two went across together.  After they went across I didn't want to do anything so I put down my work, went outside and looked around the tundra."
    },
    "91": {
        "startTime": 1292.25,
        "endTime": 1313.59,
        "transcript": "Imna qavangulqa uksuq umyuaqluku.  Tua-i tekitqapiarluku tua-i tauna yug arulaillinilria.  Unaug kuik cali miqaqtaarluni makuk cenak miiqaqtaarlutek pilriik.",
        "translation": "I was remembering my dream from last winter.  It was exactly to the time he ceased seeing the water on the river bank between the ice."
    },
    "92": {
        "startTime": 1313.885,
        "endTime": 1318.7,
        "transcript": "Aren, tua-i qavangulqa im tekitkacagarluku.",
        "translation": "It was exactly the same as my dream."
    },
    "93": {
        "startTime": 1318.987,
        "endTime": 1327.32,
        "transcript": "Aren, tuani tua-i alingepiallruunga.  Alingellruunga-wa.",
        "translation": "Oh, I was scared at that time.  I was scared."
    },
    "94": {
        "startTime": 1342.25,
        "endTime": 1351.1,
        "transcript": "Aren, tua-i waniug tuaten ayuqellruunga.  Avai tuaten qanemcitamken.",
        "translation": "Oh, that is how I was.  I just told you my story."
    },
    "95": {
        "startTime": 1355.67,
        "endTime": 1363.61,
        "transcript": "Kitek, kitek makut wani assilriit qanernailnguut angalkuut canek calilallruat?",
        "translation": "Ok, ok, what did the good quiet shamans work on?"
    },
    "96": {
        "startTime": 1364.017,
        "endTime": 1381.43,
        "transcript": "Yugnek tuunriskenglallruut assirivkaraqluki. Naulluulrianek-llu tuunriskengaqameng assirivkaraqluki camek iquaraunaki assirivkaraqluki cayugnairutell'uki.",
        "translation": "They had a medicinal ritual/practice to heal people.  They healed the sick to the end, made them well again giving them more time to live."
    },
    "97": {
        "startTime": 1381.749,
        "endTime": 1415.25,
        "transcript": "Wani-llu qasgimi tuunriaqameng imkut umyuarrlulriit yuk tauna pillrulliniaqatgu angalkut ilait camek-wa catailnguq man teguarkamek-llu catailnguq.  Waten tuai talliteng piqerrluki cayuurata cayuuqerarkailnguut-wa camek.  Cayuurata angalkut iliit taklainanermini makqetaraqluni.",
        "translation": "In the qasgiq when they worked on people who were getting ill from bad shamans, some of them used their arms and make pulling motion holding nothing and a shaman while laying flat would sit up and down.  They were not holding a thing."
    },
    "98": {
        "startTime": 1415.63,
        "endTime": 1424.176,
        "transcript": "Tua-i-gguq tauna taum naulluulriim naulluuvkartii.",
        "translation": "He was the one who made the ill, sick."
    },
    "99": {
        "startTime": 1424.85,
        "endTime": 1432.89,
        "transcript": "Tua-i qaillun meciirviinateng uitalallruut tuaten pikngait.",
        "translation": "Oh, they couldn't deny when they had been caught."
    },
    "100": {
        "startTime": 1433.18,
        "endTime": 1439.286,
        "transcript": "Makqetaalalriit tamakut meciirviinateng uitalallrulliniut.",
        "translation": "The ones who sat up and down, sat and had no way of denying doing anything."
    },
    "101": {
        "startTime": 1439.524,
        "endTime": 1448.68,
        "transcript": "Qaillun-llu pillrunritniluku qanerviinateng.  Tua-i tuaten",
        "translation": "They couldn't say they didn't do anything to him/her.  That's how."
    },
    "102": {
        "startTime": 1448.809,
        "endTime": 1465.98,
        "transcript": "Tuaten tua-i yuut amlleret cali qinuciaratullruut. Ilaita angalkut makut qanernaarailnguut tuunritaqamegteki-llu augariilluki tuavet naivvluki  umyuarrlilriamun angalkugmun.",
        "translation": "That's how alot of people talked about them.  The shamans said to be good at the time of ritual were pardoned but were transfered to a bad shaman with evil intention."
    },
    "103": {
        "startTime": 1466.192,
        "endTime": 1470.172,
        "transcript": "Tuaten tua-i ayuqellruut.",
        "translation": "That's how they were."
    },
    "104": {
        "startTime": 1470.62,
        "endTime": 1494.65,
        "transcript": "Paivvluki ellaitnun tunluki nalluatgun-llu wall'u maaggun tua-i nauggun tangrumanrilngurkun tua-i ellaita tua-i atungaqluku tamana tuaten umyuarrlullerteng. Ellaita tua-i... ellaitnun tut'aqluni umyuarrlullrat.",
        "translation": "They put it out to be seen and returned it to them unknowingly or invisibily what became their evil intention.  They or to them it came around back at them."
    },
    "105": {
        "startTime": 1495.24,
        "endTime": 1508.676,
        "transcript": "Tuaten ayuqellruut.  Tua-i qaqilluki-llu nallunritenrilkenka ilait tua-i taugaam waten tua-i niigartetullruanka.",
        "translation": "That's how they were.  I don't know all of it completely but that 's what I had heard briefly."
    },
    "106": {
        "startTime": 1512.17,
        "endTime": 1530.56,
        "transcript": "Ellangyugallerpeni imumi tayima arcaqerrluku una erneq tekilluku qanruyun neq'akngan cali, cali umyuarpeni mistuluni uitalria qanrutkeqerr'u.",
        "translation": "Since you became aware back then especially up to today what is a teaching you remember or sticks out in your mind you can share."
    },
    "107": {
        "startTime": 1530.949,
        "endTime": 1539.19,
        "transcript": "Qanruyutet niitelalten imumi avani nasaurlullraullerpeni ciuliarpenek.",
        "translation": "What are the teaching you heard long ago from your elder's when you were a giirl."
    },
    "108": {
        "startTime": 1539.27,
        "endTime": 1543.52,
        "transcript": "Atam avani tang ciuqvaarni",
        "translation": "See, long ago in the beginning"
    },
    "109": {
        "startTime": 1547.039,
        "endTime": 1555.97,
        "transcript": "qalarucestemta imkut qalarutetullrukaitkut tuartang nunulriit.",
        "translation": "our speakers spoke to us like they were scolding."
    },
    "110": {
        "startTime": 1556.57,
        "endTime": 1571.391,
        "transcript": "Wangkurlumta niicugninaurtukut pekviirulluta aqumluta kiiryungluta-llu.  Unateput-llu mecungengluteng. Pek'arviirulluta qanrutaqakut",
        "translation": "Poor us, we listened sitting very still, and begin to sweat.  Our hands begin to sweat.  We stood still as they spoke."
    },
    "111": {
        "startTime": 1571.87,
        "endTime": 1590.34,
        "transcript": "Waten imum aanama pitullruanga 'kitak qanrucestevnek niiskuvet qanrucestevet qanra tangvakiu taqvianun.  Tuaten-llu pinalengraaten uluurteksaunaku taqvianun qanra tangvalaqiu.",
        "translation": "This is what my mom said to me, \"when you hear a teacher look at your teachers mouth until they are finished talking.  Even it feels like they are addressing you watch him/her until they are done."
    },
    "112": {
        "startTime": 1592.92,
        "endTime": 1608.73,
        "transcript": "Tua-i alerquasteka call aturluku tuatnalallruunga. Nunurngalengraaten tangvaurqiu qanrakun.  Taqkaten taugaam nutaan ulurluku.",
        "translation": "So, I followed her advice and did that.   Even it seems you're being scolded watch his/her mouth.  Look away only when they're done."
    },
    "113": {
        "startTime": 1609.13,
        "endTime": 1620.69,
        "transcript": "Tuatnalallruunga.  Ilumun tuatnatulleq yuk qanruyucillminek nalluyaguciiyuitelliiniuq.",
        "translation": "That's what I did.  Surely, anyone who took in knowledge like that doesn't forget it."
    },
    "114": {
        "startTime": 1620.768,
        "endTime": 1638.805,
        "transcript": "Maa-i pekviirulluta niicugnilallruukut taqkacagaakut taugaam taum qanrucilriim nutaan tua-i nangerrluta tua-i unitaqluku.  Taqeq'apiariikut taugaam.",
        "translation": "Then, we stood very still and listened and when the speaker was done, we could get up and leave.  Only when he's finished."
    },
    "115": {
        "startTime": 1639.042,
        "endTime": 1650.9,
        "transcript": "Unilluku nangertaqluta tua-i taqaqaakut taugaam.  Nunurnganata niicugninauput nekanaqnganateng nunurnganateng.",
        "translation": "We stood and left when they're done talking to us.  It was like scolding us as we listened with emotional pain and they're like scolding."
    },
    "116": {
        "startTime": 1651.02,
        "endTime": 1672.952,
        "transcript": "Pinaurtut.  Aren maa-i tang ayuqucirtuutellrita ilait tekitaqamki elitaqlaqenka.  Elitaqaqluku ca tamalkuan elitaqaartaqluku imna qanerturalriit qanrutekvakalallrita ilait.",
        "translation": "They did that.  So, now I recall those teaching and recognize them when I reach it.  I recognize all of it or remember some of what the speaker repeated to us."
    },
    "117": {
        "startTime": 1673.079,
        "endTime": 1676.673,
        "transcript": "Caugat tamakut wani iliat qanruyutet?",
        "translation": "What were some of those wise words?"
    },
    "118": {
        "startTime": 1676.913,
        "endTime": 1698.362,
        "transcript": "Pulengtaarturluteng-llu qanrutlallruitkut. Imna qanruyutellerteng egmirrluku cali pulenglluku cali qanrutkaqluku.",
        "translation": "They told us the same thing over again.  Their wise words were knowledge passed on and were said more than once."
    },
    "119": {
        "startTime": 1699.05,
        "endTime": 1706.71,
        "transcript": "Aren, tua-i ilumun piciulriamek qanlallrulliniut augkut ciuqliit yuut.",
        "translation": "So, what they said were pretty accurate from those people back then."
    },
    "120": {
        "startTime": 1707.11,
        "endTime": 1722.73,
        "transcript": "Tua-i taumek cali imna makunek call maa-i waten-llu imkulrianek makunek-wa qaneryariurtet ilaitnek yugnek.",
        "translation": "So, now we have speakers of the good word (bible) who are our own people."
    },
    "121": {
        "startTime": 1722.809,
        "endTime": 1729.93,
        "transcript": "Augna-llu ciuqliq atuyunairutniluku qanelrianek niitaqama",
        "translation": "And when I hear that our first teachings are invalid to use"
    },
    "122": {
        "startTime": 1730.126,
        "endTime": 1740.296,
        "transcript": "wall'u augna ciuqliq atuyunairutniluku qanelrianek niitaqama waten umyuarteqlalrianga.",
        "translation": "or that it cannot be used anymore, when I hear that, I think"
    },
    "123": {
        "startTime": 1740.502,
        "endTime": 1747.977,
        "transcript": "Umyuaqeqalaqka Jesus-aaq waten qanellra.",
        "translation": "of Jesus and what he said."
    },
    "124": {
        "startTime": 1748.747,
        "endTime": 1761.65,
        "transcript": "Wiinga waniwa qaneryaraq alerquun piunrirrluku tekitenritua taugaam qaqicarturluku.",
        "translation": "I am now here not to destroy teachings and the law but to finish the work."
    },
    "125": {
        "startTime": 1762.567,
        "endTime": 1772.85,
        "transcript": "Caraungraan man'a ciuqlirtaq inerquutellrunritaa watqapik taugaam qaqicartullni qanrutkellrua.",
        "translation": "He didn't say that any of our first teaching were forbidden but said he was here to complete a mission."
    },
    "126": {
        "startTime": 1773.78,
        "endTime": 1808.852,
        "transcript": "Tua-i umyuaqellagturatuaqa waniwa waten qanellra uum Jesus-aam.  Tua-i waniug.  Waniwa tang waten elliama imkut qanruyutkelallrenka tekitaqamki tua-i yugnek-llu elitaqiaqama imkut qanerturallrit qanrit tua-i elitaqaarnaunka.",
        "translation": "I always think of what Jesus said.  Always and see at my age now I remember everytime I reach it and when I recognize it in other people the sayings from those mouths I watched come to me."
    },
    "127": {
        "startTime": 1809.452,
        "endTime": 1821.004,
        "transcript": "Yuk-llu tauna tuaten qaill ayuqeciqnilallrat tekitaqan tua-i imna qanrutkumalria tua-i neq'aqaaqluku.",
        "translation": "They also had a premonition of someone's future and I remembered the statements at that juncture."
    },
    "128": {
        "startTime": 1821.242,
        "endTime": 1828.55,
        "transcript": "Qaillun ayuqeciqnilallrat.  Tuaten tua-i ayuqelallruut.",
        "translation": "They described how they would turn out.  So, that's how they were."
    },
    "129": {
        "startTime": 1828.75,
        "endTime": 1840.838,
        "transcript": "Tuamta-llu waniug qanrusnginanrani qalarusnginanrani-llu yuut iliit nasaurluullgutemta-ll iliit an'ngan awavialar'aa.",
        "translation": "And sometimes while a young girl my age walked away while they are speaking to us, he would say."
    },
    "130": {
        "startTime": 1841.49,
        "endTime": 1864.83,
        "transcript": "Alingnaqvaatanem augumi, ciin tanem augna an'a.  Niicugniiyuumiilami-wam tua-i avai anllilria. Eliin umyuani assikekni aturturluku yuunaluni.",
        "translation": "Oh my that one, why did she go out.  Perhaps she didn't want to listen and left.  So, she will only follow what is good for her life."
    },
    "131": {
        "startTime": 1865.333,
        "endTime": 1881.206,
        "transcript": "Waten qanrutkaqluku.  Assiikekngaa tangerqaku elliinek tangerciqniluku. Tua-i waten pinauraat.",
        "translation": "That's what they said about him/her.  When she likes something she will see it herself.  That's what they said of him/her."
    },
    "132": {
        "startTime": 1881.496,
        "endTime": 1897.46,
        "transcript": "Aling aren-qiapakar tua-i alerquutet augkut ciuqliit assiilnguunritqapiartut.  Taumek aturtellrit imkut yuut yuunertuluteng-llu yuullrulriit.",
        "translation": "Oh my goodness, those initial sayings for proper conduct were not bad.  That's why they lived long when they followed them."
    },
    "133": {
        "startTime": 1897.815,
        "endTime": 1922.887,
        "transcript": "Pekcetaqaceteng-llu enruaraurluit cingquruaqluteng.  Tua-i-gguq enem'egnek yuuluteng.  Wall tegulautengqelallruut-llu tuntunek.  Curuitnek.  Cingqerrunaurtut.  Tuamtell nek'anun uitallerkaanun elliatni enruaraurlui imkut tuar nutgalalriit.",
        "translation": "When they moved them their fragile bones crackled.  They were out of position.  They used tuntu skin for carrying.  There bedding.  They crackled.  When they placed where they will rest you can hear bones make shooting noise."
    },
    "134": {
        "startTime": 1923.2,
        "endTime": 1936.44,
        "transcript": "Tua-i-gguq enem'eggnun ekluteng.  Ili tangerrluku, ug'aani yuum yuuyaraq cupuirluku. Unguvayaraq cupuirluku.",
        "translation": "They (joints) had apparently moved back in place.  See, that person had lived to the fullest.  Life to the fullest."
    },
    "135": {
        "startTime": 1936.65,
        "endTime": 1948.27,
        "transcript": "Ilait-llu-gguq keggutengnaurtut keggukaraangelrianek tamakut pinaurait.  Tuarpiaq-gguq keggutait imarmiucinraat.",
        "translation": "Some grew new teeth, which they called that stage, growth of new teeth.  They describe their teeth to be like mink's teeth."
    },
    "136": {
        "startTime": 1948.356,
        "endTime": 1959.482,
        "transcript": "Tua-i-gguq keggukarangelriit.  Tua-i atak wiinga-llu-tuq waniug keggukaranglii keggutairutellrianga tang.",
        "translation": "They had new teeth growing.  I really wish I have new teeth come out because I've lost mine."
    },
    "137": {
        "startTime": 1959.622,
        "endTime": 1977.14,
        "transcript": "Keggutairuqaarluteng-qaa tamakunek...Keggutairuqaarluteng tamakunek cimingaqluteng.  Aren, wiingaurluq tang waniug augutun ayayuallemtun ellilrianga. Ilngircetaqlua kegg'uteka una arulangaqan.",
        "translation": "You mean they lost their teeth and those...they lost their teeth and were replaced by those.  Poor me, I'm not like my youthful stage now.  I have my tooth pulled when it's moving."
    },
    "138": {
        "startTime": 1977.314,
        "endTime": 2018.54,
        "transcript": "Wani-wa-llam qavcin ukut arulalriit pingayun.  Arulangelriit.  Tua-i man'a-llu qulirneq keggutailnguq. Keggutairutellria atauciq-wa un keggutnguara.  Tuamtall man'a ukalirneq kegg'utairulluni.  Malruk-wa ukuk keggutek.  Man'a-llu atlirnek kan'aug kanani atauciq keggun.  Ukut-wa qavcir'aan waniwa uatiini.  Akiataugken man'a atlirneq man'a tua-i ilangarteksailnguaqtarluteng.",
        "translation": "Right now, there are how many, three moving. They're moving.  So, the top has no teeth left.  Toothless except only one.  And this side has no teeth left.  Except these two.  Bottom has one teeth below.  And several left further back.  Bottom of the other side so far has not lost any teeth."
    },
    "139": {
        "startTime": 2018.64,
        "endTime": 2046.36,
        "transcript": "Tamakut-qaa yuunertullret avai qanelriaten cingqurruaqluteng enrit.  Yuut-qaa yuunialallruut aknirqelluteng wall'uq...Yuuniarayuunateng akngirngalngermeng yuuniarayuunateng.",
        "translation": "Those that lived a long life had crackling bones.  Did people cry about the pain or...They didn't cry...ven they looked hurt they didn't cry."
    },
    "140": {
        "startTime": 2046.47,
        "endTime": 2059.32,
        "transcript": "Elliaqaceteng-llu tua-i mengqullagangnaurtut.  Tua-i-gguq enem'eggnun ekluteng iquit yuullermeggnek.",
        "translation": "When they were placed down joints made noise indicating they had relocated from their dislocation."
    },
    "141": {
        "startTime": 2059.5,
        "endTime": 2094.398,
        "transcript": "Aren-qia wangkuta-tall augna maurlurlurput akleng tua-i upakatarlutall pekcetaaqatni curuanek tuntumek teggulaucirluku.  Tua-i tuatnalalria tua-i ayaulluku-llu kevekluku uitallerkaanun tuamtell elliatni acia maqaqluku.  Tua-i call enruaraurlui tuai cingqerr'uluteng tuai enemegnun-gguq ekluteng.  Alingnaqvaa.",
        "translation": "Oh my, our dear grandmother, poor when we moved she was on a caribou skin to move her.  That's what happened, moving her, carrying her and they put something warm around and under her.  Her fragile bones would make the sound of getting back in place.  Goodness!"
    },
    "142": {
        "startTime": 2094.67,
        "endTime": 2126.53,
        "transcript": "Tauna tua-i qanemcitlallruakut cali taum Maurlumta ayuqucillminek.  Uingyaaqellruuq-gguq taumek angutet iliitnek angalkugmek-llu-gguq aprumaluni. Uini-gguq tauna tua-i murilkellrunritaa. Tua-i canianun-llu-gguq inarcuunani.  Itraqan-llu-gguq unugmi unitaqluku.",
        "translation": "That one told us stories our Grandmother and how she was.  She got married to one of the men who was known as a medicine man.  She didn't watch her husband.  She didn't sleep by him.  When he came in at night, she left."
    },
    "143": {
        "startTime": 2127.13,
        "endTime": 2158.736,
        "transcript": "Tua-i caqerluku taum tua-i uingan unitellinikii.  Nuliqsugyaaqengermiu-gguq uniteqatarluku uptellria. Tua-i unitellran kinguani.  Keggani keggai qakmani. Cakcaarmiunek-qaa niitetuten?  Qaluyaat ukatiitni.  Cakcaarmiunek.  Ingrit ukatmun iquitni.",
        "translation": "So, one day her husband left him.  He want her as a wife but he got ready to leave.  After he left her.  Out there, right out there next door.  You've heard of the people of Cakcaaq?  The end of the mountains coming this way."
    },
    "144": {
        "startTime": 2158.866,
        "endTime": 2186.931,
        "transcript": "Atam tuani tua-i uinguangyaaqellinilria uinguangyaaqluni.  Allam augum tekilluku angutem.  Angutem-gguq assipiam Alaskam iluani ayuqailnguum.  Iirren, tua-i elliin-llu assikngamiu ingluliurluku yuk tauna nukalpiaq assilria.",
        "translation": "At that time, she imagined she had a husband.  There was another man who came to her.  He was a handsome man and there was no other like him in Alaska.  She even liked this very nice young man."
    },
    "145": {
        "startTime": 2187.191,
        "endTime": 2202.863,
        "transcript": "Akleng, maaten-gguq tang imna caqerrluku tua-i.  Caqerluni-am payugtelliniluni.  Payugtarkani-gguq amlleraata qantat atliat tegumiaqaqaa.  Makut-wa-gguq qalliqluteng wavet.",
        "translation": "Poor, one day she was getting ready to bring him things.  She had lots to bring him with a bowl at the bottom.  They were piled up to here."
    },
    "146": {
        "startTime": 2203.133,
        "endTime": 2226.846,
        "transcript": "Tua-i igcecaaqevkenaki-gguq tuai payugtaquq.  Tua-ll nugluni tua-i qantaqestaitnun aruqutqerr'aarluki aqumluni utaqalgiraarluni anluni.  Anluni tua-i-gguq am caqerluni tuatnaraarluni an'uq tuarpiaq-gguq ca imna tan'qigpapiaq.",
        "translation": "So, carried them with care and delivered food.  So, she came up, handed the bowls and sat and waited then left.  She went out and one time after doing the same she went out and notice a bright light."
    },
    "147": {
        "startTime": 2227.83,
        "endTime": 2233.1,
        "transcript": "Iralirluni tan'qigcenani cakneq.",
        "translation": "It was full moon and bright."
    },
    "148": {
        "startTime": 2233.3,
        "endTime": 2240.77,
        "transcript": "Maaten-gguq tang qasgim amiiganek caqirrluni ukatmun piqertuq.",
        "translation": "So, as she went from the Men's house door going back this way she saw..."
    },
    "149": {
        "startTime": 2240.851,
        "endTime": 2252.956,
        "transcript": "Aqvaqatarniluku-gguq taum aipaqlallran qanrutlallrua. Aqvaqatar..aqvaniararniluku.",
        "translation": "That one who was her partner use to tell her he will get her and was going to get her soon."
    },
    "150": {
        "startTime": 2253.244,
        "endTime": 2277.04,
        "transcript": "Kana-gguq kan'a uatiit cikuyuitaa tuai uksurpak nengla qangqungraan.  Aren, qaiyaa, qayaqegtaar-wa kan'a culungqaqalria.  Yuag kan'a.  Tangerqaani-llu anguarutni nalugluku arulaarrluku taisqelluku.",
        "translation": "Down below this place the lower side doesn't freeze all winter even it's frigid cold.  Oh, his kayak...a beautiful kayak was parked on the bank and a person down there.  When she saw him he raised his paddle and moved it waving her to come on down."
    },
    "151": {
        "startTime": 2277.478,
        "endTime": 2297.318,
        "transcript": "Tua-i-guur'am kiingan ellakeqerluku tua-i aqvelria tua-i aciini-gguq tuar tutcungaqamiu tutelaaqii aqvaqullermini.  Tua-ill waniug tekitniararluku pamaken kingunranek nepa pamna aaralria.",
        "translation": "That's all she had in mind and began to run in the air as she ran or so it seemed.  As she was about to reach him, she heard a scream from above where she came from."
    },
    "152": {
        "startTime": 2298.798,
        "endTime": 2313.28,
        "transcript": "Aren-qia ayuqucini-gguq-um caleryiin ellangartuq qetqallaallinilria tuai qetqalliimi waniug qetqallallinil.",
        "translation": "So, when her body slipped she realized she had fallen, backward and backward she slid."
    },
    "153": {
        "startTime": 2313.75,
        "endTime": 2328.827,
        "transcript": "Maaten-gguq im qayaq neqaqaamiu wavet tangerqeryaaqa yaavet. Tauna-gguq ciquilqun nuuqacuayaaqerluku waniug qetqallallrullinilria qayar im tayima.",
        "translation": "She remembered the kayak, quickly looked over there.  Right before the iceless spot is where she fell but that kayak was gone."
    },
    "154": {
        "startTime": 2329.16,
        "endTime": 2345.28,
        "transcript": "Aren, tua-i catailan nutaan nangerrluni ellani man evcugluku.  Piraarlun nunat pikavet tangllinii yuk pikna eniita elatini.",
        "translation": "So, it was gone, she stood up, cleaned herself up first.  She looked up to the village and there stood someone in front of her house."
    },
    "155": {
        "startTime": 2345.459,
        "endTime": 2363.495,
        "transcript": "Tua-i nutaan tag'uraallinilria.  Aren, tagnginanermini tua-i-gguq at'atang imkut qantat tegumiallni neqangkiliki.  Aren imkuskiq qantarugaat tegumiallrenka natmun tayim piniartat.",
        "translation": "She slowly went back up.  So, while she went up, she started to wonder about the bowls she had.  So, those many bowls I carried, where are they?"
    },
    "156": {
        "startTime": 2363.73,
        "endTime": 2389.2,
        "transcript": "Aren, maaten-gguq tua-i yuk tauna tekitevkenaku qasgim elatiinek taun qayaq tangellruamiu tam'avet ellillruyukluki qantat ullagluki.  Yuum taum pia, \"waqaa natmun ayagcit?  Tai tai.\"   \"Uitaqaa, qantat imkut paqteqataranka.\"",
        "translation": "So, she didn't reach that person but because she saw the kayak in front of the Men's house she thought she put the bowls there and was going there.  That person asked, 'Hi, where are you going?  Come here.\"  \"Hold on, I'm checking on the bowls.\""
    },
    "157": {
        "startTime": 2389.375,
        "endTime": 2407.91,
        "transcript": "Aren, tekicaaqaagguq tauna tangerrvillni qayamek qantartaunani man qasgim elatii.  Aren, avatiit-gguq man'a elaqvaq kiarrluku cat paugkut tung'uuralriit tuai pavani keluqvani elaqvani.",
        "translation": "So, when she got to the spot where she first saw the kayak, there were no bowls by the men's house.  So, she looked past and around there and saw black things behind and much further out."
    },
    "158": {
        "startTime": 2408.13,
        "endTime": 2417.973,
        "transcript": "Maanten-gguq atatang imkut ullagluki pii qantat imkut tegumiaqellri.  Nerkuamek-llu-gguq imaunateng.",
        "translation": "She went to them and realized they were the bowls she had in her hands. And not a single clean bone in any of them.  (Laughter)"
    },
    "159": {
        "startTime": 2418.24,
        "endTime": 2428.985,
        "transcript": "Aren, tuai-ggur'am avuqiliki naangata taugaam tuai taqluni.  Egtellrullinikai-gguq-am tua-i yauvanun.",
        "translation": "So, then she collected all of them until she finished.  She had thrown them out pretty far."
    },
    "160": {
        "startTime": 2429.105,
        "endTime": 2445.92,
        "transcript": "Aren, tuai-gguq taun nutaan yug ullagluku tua-i itrulluku.  Itrucaamiu tuai, itrucaku taukut enem yuan cik'arutellniluku tauna im nasaurlurluq.",
        "translation": "So, she finally went to that person who yelled at her and she took her in.  Once inside a house, the household members circled around the girl."
    },
    "161": {
        "startTime": 2446.318,
        "endTime": 2451.93,
        "transcript": "Qaillun pilria cikuilnguum tungiinun aqvaquryaaqucianek?",
        "translation": "Asking her why she had ran towards the water?"
    },
    "162": {
        "startTime": 2452.699,
        "endTime": 2463.27,
        "transcript": "Qayam-gguq-wa augum taisqengani nuluraani anguarutni kevegluku atraqercaaqellrulria.",
        "translation": "She said she had seen a a kayak and that one who lifted, waved at her with his paddle had made her hurry down."
    },
    "163": {
        "startTime": 2463.914,
        "endTime": 2485.0,
        "transcript": "Tam'aani-llu-gguq tang tua-i caqatarluni kepuriqaatarluni-llu napani qagna napalian anlaryaaqellrulria.  Anenaurtuq-gguq kepurarugaat ukut ak'a taqellrullinilriit.  Iterquriluni-gguq taugken.",
        "translation": "At that time, she got ready to do something like cutting trees out there and went out.  She would find a bunch of cut wood already done once outside.  She would carry them in though."
    },
    "164": {
        "startTime": 2485.18,
        "endTime": 2497.82,
        "transcript": "Tuamta-llu-gguq taukunek canek ciqluarcesqengatni elagyamun anaurtuq-gguq ak'a tauna imkunek pisqutaitnek imangelliniaqelria.",
        "translation": "And when she was told to get food from the cache, she would go out to find the requested food all ready inside a container."
    },
    "165": {
        "startTime": 2498.12,
        "endTime": 2511.61,
        "transcript": "Cunawa-gguq tuai taum tekitaartiin.  Imiraqluki tuai aqvawailgaki taukut pisqutait enem yuin.",
        "translation": "From that one who was coming to her.  He filled the container household wanted"
    },
    "166": {
        "startTime": 2515.194,
        "endTime": 2546.811,
        "transcript": "Apqalliinikiit tua-i.  Atam ukut-wani tuunritqataqallinikiit qasgimi.  Tuani-gguq taum apqiita En'ariissuutem tuunritlermini-gguq qanrutkellrua, 'akleng-gguq tuarpiaq-gguq waniug nasaurluum um acia avelngaat nuniit.  Uugnaraat.",
        "translation": "They declared to heal her in the men's house.  The one doing his healing ritual (En'ariissuutem) said this of her, \"pitiful, it's as if underneath the girls bedding was home to mice.  Many mice."
    },
    "167": {
        "startTime": 2547.143,
        "endTime": 2563.462,
        "transcript": "Tua-i-gguq tumyaraulria naken iluvaqtaallrit taum angutem tumyaraulria.  Acia-gguq tua-i imna tuaten ayuqluni. Tauna taum nasaurluum acia.",
        "translation": "There were many trails from everywhere, man's trail.  That's how it was underneath the girls bedding."
    },
    "168": {
        "startTime": 2563.568,
        "endTime": 2596.784,
        "transcript": "Aren, tua-i-gguq tauna nasaurluq inartaquq.  Tua-ll inangqaluuni qelemngaluni-llu uitaqainanermini ellakegtaarnimek mat'umek narteqertelluuni tauna tuai pugluni amigkun.  Amingqetullratni-gguq igcaranek kalvagyaranek.  Tuai-gguq tailuni tauna imna nasaurluq angulallrukii taum nukalpiam.",
        "translation": "Oh the girl often went to bed.  As she layed, with eyes closed waiting she smelled nice fresh air and he would come through the door.  When they had tunnel doorways. That young man would come in and take care of that girl."
    },
    "169": {
        "startTime": 2597.154,
        "endTime": 2657.181,
        "transcript": "Aren tuai, nutaan tuai qasgimi iluani tuunritqatartiin taum inuguagnek malrugnek angutnguaqelriignek qasgilluteng qasgillinilriit. Tuai-gguq taum tuunricestiin tuunricestii tauna arnaruamek ayagcecillruuq.  Taum tungiinun iluvaqtaartiin.  Ayagcecillruuq.  Tauna-llu-gguq nasaurluq taumek angutnguamek taun iluvaqtaalria iluircirluku. Taum nasaurluum nuuniintelluku taun angutnguaq.  Tuai qaill taum angutem ullangermiu tekisngairulluku.  Taum iluiqani angutguam inuguam.",
        "translation": "Oh then they got ready to heal her medicinally using two miniature dolls, male and female taking over the men's house.  So the one who performed the healing practice sent a pretend female leave her toward that one who kept coming to her.  He made her leave.  And with her, a male doll was placed next to the girl being the dominant one to block off the man from reaching her.  When that male takes over."
    },
    "170": {
        "startTime": 2657.727,
        "endTime": 2678.454,
        "transcript": "Tuaten tuai atam nutaan taunaurluq imna maurlurlurput assiriyartullinilria tuaten tuai taum tuunricestellmi kinguani.  Assiriluni tuai qaillun ayuqsugnairulluni tuai ayuqellinilria.",
        "translation": "That's how that one, our poor grandmother was on the road to recovery after the medicine men worked on her.  She was well and changed from there on."
    },
    "171": {
        "startTime": 2679.139,
        "endTime": 2689.6,
        "transcript": "Aren, tua-llu.  Tua-i assiri, assiri...",
        "translation": "So, that was getting well."
    }
};